import { Box } from '@mantine/core';
import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { links } from 'src/router/routes';

import styles from './styles.module.css';

type Props = {
  id: number;
  name: string;
  description: string;
};

export const InteractionDictionaryBox: FC<Props> = memo(
  ({ id, name, description }) => {
    return (
      <Box className={styles.box}>
        <Link
          className={styles.link}
          to={`${links.interactionDictionary}/${id}`}
        >
          <img
            alt={`${name} poster`}
            className={styles.poster}
            //TODO: use imageSrc
            src="https://picsum.photos/270/480"
          />

          <div className={styles.content}>
            <div>
              <h4 className={styles.title}>{name}</h4>
              <p className={styles.description}>{description}</p>
            </div>
          </div>
        </Link>
        <Button variant="outline" className={styles.addButton}>
          <Link to={`${links.interactionNew}/${id}`}>
            <Icon className={styles.addButtonIcon} name="add" />
          </Link>
        </Button>
      </Box>
    );
  }
);
